import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customOptionsMapping',
})
export class CustomOptionsMappingPipe implements PipeTransform {
  transform(value: any, args: any[]): any {
    const options: any[] = args[0];
    const labelKey: string = args[1] || 'name';
    const valueKey: string = args[2] || 'value';
    const option = options.find((item) => item[valueKey] === value);
    if (option) {
      return option[labelKey] ?? value;
    } else {
      return value;
    }
  }
}
